import React from 'react';

import Labels from "../../../assets/labels";
import { Controller, useFormContext } from 'react-hook-form';
import { TextInput, useLang } from '@manulife/mux';
import { NormalText } from '../../../assets/appStyledComponents';

function RtgSynClientName() {
    const selectedLang = useLang();
    const { control } = useFormContext(); // retrieve all hook methods
    return (
        <>
            <Controller
                control={control}
                name="rtgSynClientName"
                render={({
                    field: { onChange, onBlur, value, name, ref },
                    fieldState: { error },
                }) => (
                    <TextInput
                        label={<>
                            {Labels.clientName[`${selectedLang}`].label} <NormalText style={{ display: "inline" }} ariaLabel={`${Labels.optional[`${selectedLang}`].label}`}>({Labels.optional[`${selectedLang}`].label})</NormalText>
                        </>}
                        aria-label={`${Labels.clientName[`${selectedLang}`].label}`}
                        customStyle={{
                            rootStyle: {
                                width: "100%",
                            },
                        }}
                        ref={ref}
                        value={value}
                        onBlur={onBlur}
                        onChange={onChange}
                        errors={error ? [error.message] : undefined}
                        callouts={false}
                    />
                )}
            />
        </>
    )
};

export default RtgSynClientName;